<template>
  <v-btn
    variant="flat"
    color="error"
    prepend-icon="mdi-delete-outline"
    :disabled="isDisabled"
    @click="emit('delete-button-clicked')"
  >
    {{ ctaText }}
  </v-btn>
</template>

<script setup lang="ts">
type Props = {
  ctaText: string;
  isDisabled?: boolean;
};

type Emits = {
  'delete-button-clicked': [];
};

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>
